import { useContext } from "react";

import { CompletionModalContext } from "./Context";

const useCompletionModal = () => {
  const context = useContext(CompletionModalContext);

  if (!context) {
    throw new Error("useCompletionModal must be used within a CompletionModalProvider");
  }

  return context;
};

export default useCompletionModal;
